import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PageHeaderWithButtons } from 'components/shared'
import { AppUrls } from 'common/AppUrls'
import { useTranslation } from 'react-i18next'
import { Switch } from 'antd'
import { setIntegrationNumberSearch, setSearchOnlyKavkomCrm } from 'store/actions/settings'
import './Integration.scss'
import { DefaultKavkomIntegration } from 'common/Globals'

export const Integration = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { integration, getProfileFinished } = useSelector((state) => state.profile)
    const { integrationNumberSearch, searchOnlyKavkomCRM } = useSelector((state) => state.settings)
    const integrationIsDefault = integration?.key === DefaultKavkomIntegration.key
    const isSearchLeadSupported = integration?.find_contact

    const toggleSearchLead = (checked) => {
        dispatch(setIntegrationNumberSearch(checked))
        !checked && toggleSearchKavkomOnly(false)
    }

    const toggleSearchKavkomOnly = (checked) => {
        dispatch(setSearchOnlyKavkomCrm(checked))
    }

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.settings} pageName={t('integration')} />
            {getProfileFinished && (
                <>
                    <div
                        className={`integration__item d-flex justify-content-between align-items-center ${
                            !integrationIsDefault && searchOnlyKavkomCRM && 'opacity-5'
                        }`}
                    >
                        <p>
                            <span className="h6">{`${t('installed_integration')}:`}</span>
                        </p>

                        <a
                            className="button d-flex align-items-center"
                            href={integration.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {integrationIsDefault ? (
                                <>
                                    <img
                                        src={integration.logo}
                                        className={`integration__logo ${integration.name.toLowerCase()}`}
                                        alt={integration.name}
                                        width={integration.logoParams?.width || 'auto'}
                                        height={integration.logoParams?.height || 'auto'}
                                    />
                                    <span className="text-secondary text-nowrap mx-1">{integration.name}</span>
                                </>
                            ) : (
                                <img src={integration.logo} width="54" alt="Integration Logo" />
                            )}
                        </a>
                    </div>
                    <div className="integration__preferences">
                        <span className="call-preferences__title">{t('preferences')}</span>
                        {isSearchLeadSupported && (
                            <div
                                className="call-preferences__item d-flex justify-content-between"
                                data-toggle="tooltip"
                                tooltip={t('search_lead_tooltip')}
                            >
                                <span>{t('search_lead_number')}</span>
                                <Switch
                                    className="app__switcher ml-3"
                                    size="small"
                                    checked={integrationNumberSearch}
                                    onChange={toggleSearchLead}
                                />
                            </div>
                        )}
                        {(!integrationIsDefault && integrationNumberSearch) ||
                        (!integrationIsDefault && !isSearchLeadSupported) ? (
                            <div
                                className="call-preferences__item d-flex justify-content-between"
                                data-toggle="tooltip"
                                tooltip={t('search_kavkomcrm_tooltip')}
                            >
                                <span>{t('search_kavkomcrm_only')}</span>
                                <Switch
                                    className="app__switcher ml-3"
                                    size="small"
                                    checked={searchOnlyKavkomCRM}
                                    onChange={toggleSearchKavkomOnly}
                                />
                            </div>
                        ) : null}
                    </div>
                </>
            )}
        </>
    )
}
